const Connection = () => {
  return (
    <>
      <section id="conexoes" className="content-section">
        <div className="card mb-3">
          <div className="card-body text-center">
            <h5 className="card-title">Conexões</h5>
          </div>

          <div className="card-body">
            <div className="card">
              <div className="card-body">
                <ol className="list-styled">


                  <div>
                    <p className="mb-0">
                      <strong>Dispositivos conectados</strong>
                    </p>
                    <p className="justified-text">
                      Permite acessar informações sobre os clientes conectados via Wi-Fi ou rede cabeada.
                    </p>

                    <div className="d-flex justify-content-center">
                      <img src="./res/figures/dispositivos-conectados.png" className="card-img-bottom img-lg img-xl" alt="" />
                    </div>

                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Interface: </strong>permite filtrar os equipamentos por interface: Wireless, Ethernet ou Qualquer.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>SSID: </strong>permite filtrar os equipamentos por SSID.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Tipo: </strong>permite filtrar os equipamentos pelo tipo: DHCP, Estático, Desconhecido ou Qualquer (disponível apenas em modo roteador).
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Pesquisar equipamentos: </strong>possibilita a busca de equipamento(s) por SSID, hostname ou endereço MAC.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Atualizar: </strong>atualiza a lista de dispositivos conectados.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Desconectar: </strong>efetua a desconexão do cliente Wi-Fi selecionado.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Bloquear no SSID conectado: </strong>bloqueia a conexão do cliente selecionado no SSID onde está conectado.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Bloquear em todos os SSIDs: </strong>bloqueia a conexão do cliente selecionado em todos os SSIDs.
                        </p>
                      </li>
                    </ul>
                  </div>

                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Connection;
